import { render, staticRenderFns } from "./CidRestore.vue?vue&type=template&id=a95f2644"
import script from "./CidRestore.vue?vue&type=script&lang=js"
export * from "./CidRestore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports